import React from 'react';
import M from 'materialize-css/dist/js/materialize';
import BaseComponent from '../../../components/BaseComponent';
import { Button } from '../../../components/UI/ComponentsUI';
import { translate } from '../../../utils/util';

class ReceiptContainerModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                justificationId: '',
            },
            validations: [
            ],
        };
    }
    componentDidMount() {
        this.instance = M.Modal.init(this.modal);
        this.instance.dismissible = false;
        this.instance.options.dismissible = false;
    }

    close() {
        M.Modal.getInstance(this.modal).close();
    }

    onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.close();
    };

    show() {
        this.instance.open();
    }

    onConfirm = () => {
        if (this.props.onConfirm) {
            this.props.onConfirm()
        }
    }

    render() {
        return (
            <div id='confirm-modal' ref={(modalEl) => this.modal = modalEl} className="modal" style={{ marginTop: '20px', padding: '15px' }}>
                <p className="black-text">Confirmar recebimento de todos os desenhos vinculados ao container?</p>

                <div className="row" style={{ margin: '25px 0px 20px 0px' }}>
                    <div className="col s6 lefth">
                        <Button full="true" className="col s6" onClick={this.onCancel} text={translate('general:cancel')} />
                    </div>
                    <div className="col s6 lefth">
                        <Button full="true" className="col s6 btn-principal" onClick={this.onConfirm} text={translate('general:confirm')} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ReceiptContainerModal;
